import { render, staticRenderFns } from "./AvisForm.vue?vue&type=template&id=6fde7db3&"
import script from "./AvisForm.vue?vue&type=script&lang=ts&"
export * from "./AvisForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports